'use client'

import type { NavConfig } from '@/types/nav-types'

import { NavContextProvider } from './nav-context-provider'

interface NavRootProps {
  nav: NavConfig
  navLoader?: {
    locale: string
    version: 'draft' | 'published'
    renderMode: 'public' | 'preview' | 'dev'
  }
  children: React.ReactNode
}
// Just sets up the nav context provider
export const NavRoot: React.FC<NavRootProps> = ({ nav, navLoader, children }) => {
  return (
    <NavContextProvider nav={nav} navLoader={navLoader}>
      {children}
    </NavContextProvider>
  )
}
